/**
 * custom_app.js
 *
 * Shopify公開アプリのカスタマイズを行う。
 * Shopify公開アプリが出力するDOM要素に変更を加えるため、
 * Shopify公開アプリでアップデートが発生し、DOM要素が変更された場合には対応できず、
 * このスクリプトのメンテナンスが必要になるので注意すること。
 */

/**
 * [Wiser（レコメンドアプリ）のタイトル文字化け対応]
 * アプリで出力されるDOMを監視し、タイトルを文字化けしていない正規のタイトルに差し替える
 *
 * @param target
 */
const recommendObserveFactory = (target) => {
	const observer = new MutationObserver((records, obs) => {
		records.forEach((record) => {
			if (record.type === 'childList') {
				const productListElement = target.querySelector('.evm-wsrow')
				if (productListElement && productListElement.children) {
					// 重要：監視を停止しないと無限ループする
					obs.disconnect()
					Array.from(productListElement.children).forEach((productElement) => {
						const product = productElement.querySelector('.ws-card__header-link')
						const title = product.title
						const titleElement = product.querySelector('h3.ws-card__title')

						// decodeTitleだけで充分な気もするが念のため
						const decodedTitle = decodeTitle(htmlSpecialCharacterDecoder(title))

						titleElement.innerText = decodedTitle
						product.title = decodedTitle
					})
				}
			}
		})
	})
	observer.observe(target, {
		childList: true,
		subtree: true,
	})
}

const decodeTitle = (str) => {
  const t = document.createElement('textarea');
  t.innerHTML = str;

  return t.value;
};

const htmlSpecialCharacterDecoder = (function() {
	const map = {'&nbsp;':' ','&lt;':'<','&gt;':'>','&amp;':'&','&quot;':'"','&apos;':"'",'&copy;':'©','&trade;':'™','&reg;':'®','&lsquo;':'‘','&rsquo;':'’','&ldquo;':'“','&rdquo;':'”'};
	return function(src) {
		const re = /&#x([0-9A-Fa-f]+);|&#(\d+);|&\w+;|[^&]+|&/g;
		let text = '';
		let m;
		while ((m=re.exec(src)) !== null) {
			if (m[0].charAt(0) === '&') {
				if (m[0].length === 1) {
					// ？？？
					text = text + m[0];
				} else if (m[0].charAt(1) === '#') {
					// 数値文字参照
					if (m[0].charAt(2) === 'x') {
						text = text + String.fromCharCode(parseInt(m[1], 16));
					} else {
						text = text + String.fromCharCode(m[2]-0);
					}
				} else if (map.hasOwnProperty(m[0])) {
					// 定義済み文字実体参照
					text = text + map[m[0]];
				} else {
					// 未定義文字実体参照（諦める）
					text = text + m[0];
				}
			} else {
				// 通常文字列
				text = text + m[0];
			}
		}
		return text;
	};
})();

/**
 * [Air Product Reviews(レビューアプリ)の表示調整対応]
 * アプリで出力されるDOMを監視し、レビュー件数0件の場合の表示を整える
 *
 * @param target
 */
const reviewObserve = (target) => {
	const observer = new MutationObserver((records, obs) => {
		records.forEach((record) => {
			if (record.type === 'childList') {
				const reviewListElement = target.querySelector('.AirReviews-Blocks__ListReview')
				if (reviewListElement) {
					if (reviewListElement.getElementsByClassName('AirReviews-Blocks__ReviewDetails').length > 0) {
						obs.disconnect()
						const sortElements = target.getElementsByClassName('AirReviews-Blocks__ListSort')
						const paginationElements = target.getElementsByClassName('AirReviews-Blocks__pagination')
						for (const sort of sortElements) sort.classList.add('display-flex')
						for (const pagination of paginationElements) pagination.classList.add('display-flex')
					} else {
						const titleElement = target.querySelector('.AirReviews-Blocks--Title')
						if (titleElement.nextSibling && titleElement.nextSibling.nodeType === 3) {
							if (titleElement.nextSibling.nodeValue) {
								obs.disconnect()
								titleElement.nextSibling.nodeValue = ''
								$('.AirReviews-Blocks__Summary').after(`<div>商品のレビューを投稿してみましょう！</div>`)
							}
						}
					}
				}
			}
		})
	})
	observer.observe(target, {
		childList: true,
		subtree: true,
	})
}


$(function() {
	const similarContents = document.getElementById('similar-contents')
	const userContents = document.getElementById('user-contents')
	const historyContents = document.getElementById('history-contents')
	const cartRecommendContents = document.getElementById('cart-recommend-contents')
	const productReviewContents = document.getElementById('products-review')

	// この商品と似た商品を監視
	if (similarContents) {
		recommendObserveFactory(similarContents)
	}
	// よく一緒に見られている商品
	if (userContents) {
		recommendObserveFactory(userContents)
	}
	// 閲覧履歴
	if (historyContents) {
		recommendObserveFactory(historyContents)
	}
	// カート内レコメンド（よく一緒に購入されている商品）
	if (cartRecommendContents) {
		recommendObserveFactory(cartRecommendContents)
	}
	// カスタマーレビュー
	if (productReviewContents) {
		reviewObserve(productReviewContents)
	}
})
